import styled from 'styled-components'

export const InvoiceExportTableWrapper = styled.div`
  padding-top: 15px;
  background: ${props => props.theme.colors.white};
`
